import styled, { keyframes } from 'styled-components';

const fadeFromRight = keyframes`
from {
  opacity: 0;
  transform: translateX(50px);
}
to{
  opacity: 1;
  transform:translateX(0);
}
`;
export const Container = styled.div`
  height: 100vh;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 30px 0px;
  background: #ddd;
  width: 100%;
`;

export const Header = styled.div`
  width: 100%;
  background: none;
  color: #333;
  padding: 20px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > div {
    display: flex;
    max-width: 400px;
    form {
      display: flex;

      > input {
        border: 0;
        padding: 20px;
        background: #eee;
        color: #333;
      }
      > button {
        border: 0;
        padding: 20px;
        background: rgb(0, 100, 150);
        color: #fff;
      }
    }
  }
`;

export const Body = styled.div`
  width: 100%;
  min-height: 50vh;
  display: flex;

  > table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #ccc;
    table-layout: auto;
    background: white;
    margin-top: 10px;

    tr {
      td,
      th {
        border: 1px solid #ddd;
        text-align: left;
        color: #333;
        padding: 5px;
      }
    }

    tr + tr {
      border-top: 1px solid #999;
    }
  }
`;

/* Popup de avaliação da isenção */

export const AvaliacaoPainel = styled.div`
  /* Tokens declarados aqui: a rota do admin não emite as variáveis do design
     system, e sem elas o texto herdava o branco do layout. */
  --ds-accent: var(--ds-accent-client, #011154);
  --ds-accent-text: #011154;
  --ds-on-accent: #ffffff;
  --ds-accent-13: color-mix(in srgb, var(--ds-accent) 13%, transparent);
  --ds-ink: #241d2b;
  --ds-muted: #5f6673;
  --ds-line: #9aa4ae;
  --ds-line-soft: #dcdfe2;
  --ds-paper: #f3f5f6;
  --ds-field: #ffffff;
  --ds-surface: #ffffff;
  --ds-ok: #1f9d63;
  --ds-warn: #c9781d;
  --ds-danger: #c22222;
  --ds-info: #2563eb;
  --ds-radius-inner: 4px;
  --ds-radius-card: 6px;
  --ds-radius-pill: 999px;
  --ds-fs-micro: 11px;
  --ds-lh-micro: 16px;
  --ds-fs-xs: 12px;
  --ds-lh-xs: 16px;
  --ds-fs-sm: 13px;
  --ds-lh-sm: 18px;
  --ds-fs-body: 14px;
  --ds-lh-body: 20px;

  box-sizing: border-box;
  font-size: var(--ds-fs-body);
  line-height: var(--ds-lh-body);
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  color: var(--ds-ink);
`;

export const AvaliacaoSecao = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  padding: 12px 14px;
  background: var(--ds-paper);
  border: 1px solid var(--ds-line);
  border-radius: var(--ds-radius-card);
`;

export const AvaliacaoSecaoTitulo = styled.span`
  display: block;
  margin: 0 0 4px;
  font-size: var(--ds-fs-micro);
  line-height: var(--ds-lh-micro);
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--ds-muted);
`;

export const AvaliacaoLinha = styled.div`
  display: grid;
  grid-template-columns: 140px minmax(0, 1fr);
  gap: 12px;
  padding: 4px 0;
  border-bottom: 1px solid var(--ds-line-soft);

  &:last-child {
    border-bottom: 0;
  }

  > span:first-child {
    display: block;
    margin: 0;
    font-size: var(--ds-fs-xs);
    line-height: var(--ds-lh-xs);
    font-weight: 700;
    color: var(--ds-muted);
  }

  > span:last-child {
    display: block;
    margin: 0;
    min-width: 0;
    overflow-wrap: anywhere;
    font-size: var(--ds-fs-body);
    line-height: var(--ds-lh-body);
    font-weight: 600;
    color: var(--ds-ink);
  }
`;

export const AvaliacaoTexto = styled.span`
  display: block;
  margin: 0;
  font-size: var(--ds-fs-sm);
  line-height: var(--ds-lh-sm);
  color: var(--ds-muted);
`;

export const AvaliacaoNota = styled.div`
  --tom: var(--ds-info);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  border-radius: var(--ds-radius-inner);
  border: 1px solid color-mix(in srgb, var(--tom) 20%, transparent);
  background: color-mix(in srgb, var(--tom) 6%, transparent);

  &.warn {
    --tom: var(--ds-warn);
  }

  &.danger {
    --tom: var(--ds-danger);
  }

  > span {
    display: block;
    margin: 0;
    font-size: var(--ds-fs-sm);
    line-height: var(--ds-lh-sm);
    color: var(--ds-ink);
  }

  > label {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin: 0;
    cursor: pointer;
    font-size: var(--ds-fs-sm);
    line-height: var(--ds-lh-sm);
    color: var(--ds-ink);

    > input {
      margin: 3px 0 0;
      flex-shrink: 0;
    }
  }
`;

export const AvaliacaoPill = styled.span`
  --tom: var(--ds-warn);
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  vertical-align: middle;
  border-radius: var(--ds-radius-pill);
  font-size: var(--ds-fs-xs);
  line-height: var(--ds-lh-xs);
  font-weight: 700;
  color: var(--tom);
  background: color-mix(in srgb, var(--tom) 10%, transparent);

  &.ok {
    --tom: var(--ds-ok);
  }

  &.danger {
    --tom: var(--ds-danger);
  }
`;

export const AvaliacaoLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 24px;
  vertical-align: middle;
  font-size: var(--ds-fs-body);
  line-height: var(--ds-lh-body);
  font-weight: 700;
  color: var(--ds-accent-text);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const AvaliacaoCampo = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
  min-width: 0;

  > span {
    display: block;
    margin: 0;
    font-size: var(--ds-fs-xs);
    line-height: var(--ds-lh-xs);
    font-weight: 800;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--ds-muted);
  }
`;

export const AvaliacaoTextarea = styled.textarea`
  box-sizing: border-box;
  width: 100%;
  min-height: 96px;
  margin: 0;
  padding: 10px 12px;
  resize: vertical;
  font-family: inherit;
  font-size: var(--ds-fs-body);
  line-height: var(--ds-lh-body);
  color: var(--ds-ink);
  background: var(--ds-field);
  border: 1px solid var(--ds-line);
  border-radius: var(--ds-radius-inner);

  &:focus {
    outline: none;
    border-color: var(--ds-accent);
    box-shadow: 0 0 0 3px var(--ds-accent-13);
  }
`;

export const AvaliacaoRodape = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 12px;
  border-top: 1px solid var(--ds-line-soft);
`;

export const AvaliacaoBotao = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  box-sizing: border-box;
  font-family: inherit;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: var(--ds-radius-inner);
  font-size: var(--ds-fs-body);
  line-height: var(--ds-lh-body);
  font-weight: 700;
  cursor: pointer;
  color: var(--ds-ink);
  background: var(--ds-surface);
  border: 1px solid var(--ds-line);

  &.primary {
    color: var(--ds-on-accent);
    background: var(--ds-accent);
    border-color: var(--ds-accent);
  }

  &.danger {
    color: var(--ds-surface);
    background: var(--ds-danger);
    border-color: var(--ds-danger);
  }

  > svg {
    margin: 0;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;